import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import axiosInstance from '../../Services/axios';
import defaultimg from "../../Assets/Images/default-placeholder.png";
import { MdOutlineCurrencyRupee } from "react-icons/md";
import { IoLocationSharp } from "react-icons/io5";
import { FaLocationDot } from "react-icons/fa6";
import buy_now from "../../Assets/Images/icons/buyNow.png"

const OfferCard = ({ data, offer_from_Page }) => {

    const navigate = useNavigate();
    const expiredate = data.expiry_date || data.duration;

    const parseDate = (dateStr) => {
        const [dd, mm, yyyy] = dateStr.split("-");
        return new Date(`${yyyy}-${mm}-${dd}`);
    };



    const expireDateObj = new Date(expiredate);
    const formattedDate = expireDateObj.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric"
    });

    return (

        <div className='p-2'>
            <div className='offerCard primary-bg-light' >
                <div className='d-flex justify-content-around p-2 offerBottam'>
                    <div className='col-4 '>
                        <div className=''>
                            <img src={data.offer_image ? data.offer_image : data.offers_image} className='offerimg' height="100px" width="100px" />
                        </div>
                    </div>
                    {/* <div className='col-1'></div> */}

                    <div className='col-7 m-0 d-flex flex-column justify-content-between'>
                        <div>
                            <h6 className='m-0 ff-poppins-semiBold fs-15'>{data.offer_name} </h6>
                            <span className={` ${data.offer_type == '4' ? 'fs-10' : 'fs-12'}  ff-poppins-semiBold primary-text`}>
                                {data.offer_type == '1' ? (
                                    <>
                                        Get{" "}
                                        {data.discount_type == '1' && <span className="rupeeIcon">₹</span>}
                                        {data.discount}{data.discount_amount}{data.discount_type == '2' ? '%' : ''}
                                        {" "}Offer
                                    </>

                                ) : data.offer_type == '2' ? (
                                    <>
                                        Get{' '}
                                        {data.discount_type == '1' && <span className="rupeeIcon">₹</span>}{data.discount}{data.discount_type == '2' ? '%' : ''}{' '}Offer
                                    </>

                                ) : data.offer_type == '3' ? (
                                    'Buy & Get Offer'
                                ) : data.offer_type == '4' ? (
                                    <>Pick any {data.combo_count} at <span className="rupeeIcon">₹</span>{data.offer_price} combo offer</>
                                ) : (
                                    ''
                                )}
                            </span>


                            {
                                offer_from_Page == "search" ?
                                    <div className='d-flex justify-content-between'>
                                        <div className=' '>
                                            <p className='m-0 fs-12 ff-poppins-semiBold primary-text'>  {data.vendor_company_name}   </p>
                                        </div>
                                        <div className='m-0   fs-10 ff-poppins-medium'>
                                            <span className='fs-10 primary-text'> <FaLocationDot /></span>   {data.distance} Km
                                        </div>
                                    </div>
                                    : ""
                            }

                            {
                                offer_from_Page == "serarch_offer" ?
                                    <div className='d-flex justify-content-between border_Bootam_Line pb-2 primary-text'>
                                        <h5 className='m-0 ff-poppins-bold fs-16 '>{data?.vendor_company_name}</h5>
                                        <span className='fs-11 ff-poppins-regular mt-1'><IoLocationSharp />{data?.distance} km</span>
                                    </div> : ""
                            }



                            <div className='border-Bottom-Solid'></div>

                            {/* <hr ></hr> */}
                            <div className='p-0 ff-poppins-regular fs-9 offer_description mt-2'>
                                {data.offer_description && data.offer_description.length > 80
                                    ? data.offer_description.slice(0, 80) + "..."
                                    : data.offer_description}
                            </div>


                        </div>
                        <div className='mt-auto'>
                            {
                                offer_from_Page == "search" || offer_from_Page == "Offer_list" ?
                                    <div className='mb-1'>
                                        <img src={buy_now} height='22px' width='70px' />
                                    </div> : ""
                            }
                            <p className='fs-10 m-0 primary-text ff-poppins-medium'>
                                Expiry Date : {formattedDate}
                            </p>
                        </div>
                    </div>
                </div>
                <div className='primary-bg-light'>
                    {
                        offer_from_Page == "Offer_list" || offer_from_Page == "offerDetails" ?
                            data.usage_limit_status == '1' || data.usage_limit_status == '0' ?
                                <div className='offerLimit' >
                                    <p className='m-0'>User Limit : {
                                        data.offer_used_count ?
                                            data.usage_limit_per_user - data.offer_used_count :
                                            data.usage_limit_per_user} </p>
                                </div> : <></>
                            : ""
                    }
                </div>

            </div>
        </div>
    )
}
export default OfferCard